import React from "react";
import { Link } from "react-router-dom";
import { Button, InputFile, Loading } from "../../../common";
import * as style from "../styles.module.scss";
import { openCv } from "../../../helpers/helpers";

const CV = ({
  handleSubmitCV,
  handleCvSubmitted,
  cvUploaded,
  fileValidationError,
  loading,
  workHistoryPath = "#",
  navigateBackPath,
}) => {
  return (
    <div className={`col-sm-12 col-lg-6 mt-2 mt-lg-4 mb-2 ${style.form}`}>
      <div className={`mb-3`}>
        <p>
          Your CV must be added as a <strong>doc, docx</strong> or{" "}
          <strong>PDF</strong> file.
        </p>
        {cvUploaded && !fileValidationError && !loading && (
          <p
            className={`${style.workHistory__link} mb-3 mb-lg-2`}
            role="button"
            onClick={() => openCv(cvUploaded)}
          >
            {cvUploaded.fileName}
          </p>
        )}
        {!cvUploaded && !loading && (
          <p className={"mb-3 mb-lg-2"}>
            Don&apos;t have a CV?{" "}
            <Link to={workHistoryPath} className={`${style.workHistory__link}`}>
              Enter your work history manually
            </Link>
          </p>
        )}
        <div className={"mt-2"}>
          {cvUploaded && !fileValidationError ? (
            <InputFile
              onChangeHandler={handleSubmitCV}
              text={loading ? <Loading /> : "Update your CV"}
              classes={`btn col-12 col-sm-4 text-dark ${
                loading ? "btn-info" : "btn-outline-info"
              }`}
              idName="cvFile"
              acceptMimeTypes=".doc,.docx,.pdf"
              disabled={loading}
            />
          ) : (
            <InputFile
              onChangeHandler={handleSubmitCV}
              text={loading ? <Loading /> : "Upload your CV"}
              classes={`btn btn-primary col-12 col-sm-4`}
              idName="cvFile"
              acceptMimeTypes=".doc,.docx,.pdf"
              disabled={loading}
            />
          )}
          {fileValidationError && fileValidationError === "formatInvalid" && (
            <div className="text_invalid fontSize-12" style={{ color: "red" }}>
              This file format is invalid
            </div>
          )}
          {fileValidationError && fileValidationError === "fileEmpty" && (
            <div className="text_invalid fontSize-12" style={{ color: "red" }}>
              This file is empty
            </div>
          )}
          {fileValidationError && fileValidationError === "fileMissing" && (
            <div className="text_invalid fontSize-12" style={{ color: "red" }}>
              Please upload your CV
            </div>
          )}

          {fileValidationError &&
            fileValidationError === "fileAndWorkHistoryMissing" && (
              <div
                className="text_invalid fontSize-12"
                style={{ color: "red" }}
              >
                Please upload your CV or enter your work history
              </div>
            )}
        </div>
      </div>

      <div className={`mt-lg-auto mb-lg-2 ${style.actions}`}>
        <Link to={navigateBackPath}>
          <button className="btn btn-outline-info text-dark mr-1" type="button">
            Back
          </button>
        </Link>
        <Button
          classes="btn btn-primary btn-block"
          onClick={handleCvSubmitted}
          disabled={loading}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default CV;
